export default function ($) {
  const navp = window.document.querySelector('.navp');
  const navpContainer = window.document.querySelector('.navp-container');
  const headerContainer = window.document.querySelector('.header');
  const heroWrapper = window.document.querySelector('.hero__wrapper, .bg-video__hero') ?? false;
  const menuLink = window.document.querySelectorAll('.menu-link');
  const submenuLast = window.document.querySelectorAll('.menu-link-submenu-last');

  if (!navp) {
    return;
  }

  /**
   * Inverse header's transparency
   *
   * @param isInverse
   */
  function inverseHeader(isInverse = true) {
    const inverse = [
      '.c-hamburger',
      '.c-hamburger__item',
      '.c-logo__item',
      '.header',
      '.header__row',
      '.header__reserve',
      '.header__reserve-button',
      '.header__burger',
      '.header__link',
      '.top-menu-link',
      '.navp',
      '.navp__apx--title',
      '.navp__apx--revraise',
      '.navp__menu-link',
      '.navp__revraise-button',
    ];

    inverse.forEach((selector) => {
      const elem = window.document.querySelectorAll(selector);
      elem.forEach((item) => {
        if (isInverse === true) {
          item.classList.add('inverse');
        } else if (item.classList.contains('scroll')) {
          item.classList.add('inverse');
        } else {
          item.classList.remove('inverse');
        }
      });
    });
  }

  /**
   * stickyMenu
   *
   * @return void
   */
  function stickyMenu() {
    const header = window.document.querySelector('.header');
    const st = window.pageYOffset;
    const { body: b } = window.document;
    const { offsetTop: ot } = b;
    const d = ot + st;
    const scroll = [
      '.navp',
      '.navp__apx--title',
      '.navp__apx--revraise',
      '.navp__revraise-button',
      '.menu-link',
    ];
    let p = header.clientHeight
      + (navpContainer.classList.contains('navp-container--disabled') ? 0 : navp.clientHeight);

    if (document.querySelector('.gallery.container')) {
      p -= 10;
    }

    scroll.forEach((item) => {
      const selector = window.document.querySelectorAll(item);

      if (d > p) {
        selector.forEach((el) => {
          el.classList.add('scroll');
          el.classList.add('inverse');
        });
        setTimeout(() => {
          if (document.querySelector('.bg-video__hero') || document.querySelector('.hero')) {
            navp.classList.add('animate');
          } else {
            navp.classList.add('unanimate');
          }
        }, 50);
      }

      if (d < p) {
        let isSubmenuOpen = false;

        selector.forEach((el) => {
          el.classList.remove('scroll');
          menuLink.forEach((link) => {
            if (link.classList.contains('open')) {
              isSubmenuOpen = true;
            }
          });
          if (isSubmenuOpen === false) {
            el.classList.remove('inverse');
          }
        });
        navp.classList.remove('animate');
      }
    });
  }

  /**
   * submenuCloseAll
   *
   * @return void
   */
  function submenuCloseAll() {
    const submenuOverlay = window.document.querySelectorAll('.submenu-overlay');
    const submenuColumn = window.document.querySelectorAll('.submenu-column');
    const background = window.document.querySelectorAll('.submenu-background');

    submenuOverlay.forEach((item) => {
      $(item).stop().animate({ opacity: 0 }, 150, 'swing', () => {
        $(item).hide().removeClass('open');
      });
    });

    background.forEach((item) => {
      $(item).stop().animate({ opacity: 0, width: '50%' }, 150, 'swing', () => {
        $(item).hide().removeClass('open');
      });
    });

    submenuColumn.forEach((item) => {
      item.classList.remove('animate');
    });

    menuLink.forEach((item) => {
      item.classList.remove('open');
    });
  }

  /**
   * submenuOpen
   *
   * @param event
   * @return void
   */
  function submenuOpen(event) {
    const parent = event.target;
    const submenuOverlay = parent.nextElementSibling;

    if (parent.classList.contains('open')) {
      return;
    }

    submenuCloseAll();
    inverseHeader(true);

    if (!submenuOverlay) {
      return;
    }

    const background = submenuOverlay.firstElementChild;
    const submenuColumn = submenuOverlay.querySelectorAll('.submenu-column');

    parent.classList.add('open');

    submenuColumn.forEach((item) => {
      setTimeout(() => {
        item.classList.add('animate');
      });
    });

    $(submenuOverlay).show().stop().animate({ opacity: 1 }, 300, 'swing');
    $(background).show().stop().animate({ opacity: 1, width: '100%' }, 300, 'swing');
  }

  /**
   * submenuWidth
   *
   * @return void
   */
  function submenuWidth() {
    const navpMenu = window.document.querySelector('.navp-menu');
    const submenuBox = window.document.querySelectorAll('.submenu-box');
    const pw = navpMenu.clientWidth;

    submenuBox.forEach((item) => {
      const box = item;
      box.style.width = `${pw}px`;
    });
  }

  function beSelectBlur() {
    const roomFilter = window.document.querySelectorAll('booking-layout select');

    roomFilter.forEach((item) => {
      item.blur();
    });
  }

  window.addEventListener('load', () => {
    submenuWidth();
    stickyMenu();
  });

  window.addEventListener('resize', () => {
    submenuWidth();
  });

  window.addEventListener('scroll', () => {
    stickyMenu();
  });

  menuLink.forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      submenuOpen(event);
      beSelectBlur();
    });

    if (item.nextElementSibling) {
      item.addEventListener('keydown', (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 13) {
          event.preventDefault();
          submenuOpen(event);
        }
      });
    }
  });

  submenuLast.forEach((item) => {
    item.addEventListener('blur', () => {
      submenuCloseAll();
    });
  });

  headerContainer.addEventListener('mouseenter', () => {
    inverseHeader(true);
  });

  if (heroWrapper) {
    heroWrapper.addEventListener('mouseenter', () => {
      inverseHeader(false);
    });
  }

  navp.addEventListener('mouseenter', () => {
    inverseHeader(true);
  });

  navp.addEventListener('mouseleave', (event) => {
    if (!event.relatedTarget.closest('header')) {
      inverseHeader(false);
    }
    submenuCloseAll();
  });

  document.addEventListener('scroll', () => {
    menuLink.forEach((link) => {
      if (link.classList.contains('open')) {
        submenuCloseAll();
      }
    });
  });

  window.document.addEventListener('mousemove', (event) => {
    const container = window.document.querySelector('.navp__menu, .navp__overlay');
    if (!$(container).is(event.target) && $(container).has(event.target).length === 0) {
      submenuCloseAll();
    }
  });
}
